import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { getAssessmentCustomerRates, updateAssessmentCustomerRates } from '../../../actions/discountsAndKickback'

// import styles
import './discounts.scss'

// Utils
import { translation, enumtranslate } from '../../../utils/helpers'
// import HelpText from '../../../shared/components/HelpText'
import { hasSubscriptionPermission } from '../../../utils/auth'

// Elements
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Grid from '../../../shared/elements/grid'
import DecimalInput from '../../../shared/components/DecimalInput'

class ReportDiscounts extends Component {

  constructor (props) {
    super(props)
    this.state = {
      customerId: 0,
      assessmentRates_NoRental: {
        CustomerId: 0,
        Usage: this.props.type,
        Discounts: []
      },
      assessmentRates_Rental: null
    }
  }

  componentDidMount () {
    this.getRates(this.props)
  }
  componentWillUpdate (nextProps) {
    if (this.props.item.PriceModelId !== nextProps.item.PriceModelId || this.props.type !== nextProps.type) {
      this.getRates(nextProps)
    }
  }

  getRates (props) {
    let customerId = props.customerId
    const isKickback = this.props.hasKickback && parseInt(this.props.type) === 1
    this.props.getAssessmentCustomerRates(customerId, this.props.type).then((res) => {
      this.setState({
        customerId: customerId,
        assessmentRates_NoRental: res.data
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.router.push('/prices')
    })
    if (isKickback) {
      this.props.getAssessmentCustomerRates(customerId, (this.props.type * 10)).then((res) => { // Type multiplied by 10 corresponds to same type but with rental car.
        this.setState({
          customerId: customerId,
          assessmentRates_Rental: res.data
        })
      }, () => {
        // Toastr
        window.toastr.error(translation('13445'), translation('216'))
        this.props.router.push('/prices')
      })
    }
  }

  updateRates (group) {
    this.props.updateAssessmentCustomerRates(this.state[group]).then((res) => {
      this.setState({
        [group]: res.data
      })
      // Toastr
      // window.toastr.success(translation('15157'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.router.push('/prices')
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    const isKickback = this.props.hasKickback && parseInt(this.props.type) === 1

    const renderDiscounts = () => {
      if (this.state.assessmentRates_NoRental === null || this.state.assessmentRates_NoRental === undefined) return null

      // For bodyshop/kickback we want to render to colums of discount rows, for paintshops only one column applies,
      // so we splice the discounts from each column together in pairs if we have them.
      const hasRental = this.state.assessmentRates_Rental !== null
      let itemsNoRental = [...this.state.assessmentRates_NoRental.Discounts]
      let itemsRental = hasRental ? [...this.state.assessmentRates_Rental.Discounts] : null
      let splicedItems = itemsNoRental.map(x => {
        return {
          NoRental: x,
          Rental: hasRental ? itemsRental.find(y => y.SummationGroupConfigId === x.SummationGroupConfigId) : null
        }
      })

      const renderDiscountFields = () => {
        const onChangeAmount = (e) => {
          let nameSegments = e.target.name.split('-')
          let id = parseInt(nameSegments[1])
          let group = nameSegments[2]
          let currentGroup = this.state[group]
          let currentIndex = currentGroup.Discounts.findIndex(x => x.SummationGroupConfigId === parseInt(id))
          currentGroup.Discounts[currentIndex].DiscountAmount = e.target.value
          this.setState({
            [group]: currentGroup
          })
        }

        const onAmountBlur = (target) => {
          let value = target.value
          let name = target.name
          if (isNaN(value)) {
            // Toastr
            window.toastr.error(translation('15159'), translation('216'))
          } else if (value < 0 || value > 99.99) {
            // Toastr
            window.toastr.error(translation('15158'), translation('216'))
          } else {
            let nameSegments = name.split('-')
            let id = parseInt(nameSegments[1])
            let group = nameSegments[2]

            let currentGroup = this.state[group]
            let currentIndex = currentGroup.Discounts.findIndex(x => x.SummationGroupConfigId === parseInt(id))
            currentGroup.Discounts[currentIndex].DiscountAmount = target.value

            this.setState({
              [group]: currentGroup
            }, () => {
              this.updateRates(group)
            })
          }
        }

        const renderField = (item) => {
          let noRentalDiscount = item.NoRental
          let rentalDiscount = item.Rental

          const renderNoRental = () => {
            return (
              <DecimalInput
                name={'SumGroupId-' + noRentalDiscount.SummationGroupConfigId + '-assessmentRates_NoRental'}
                value={noRentalDiscount.DiscountAmount}
                onChange={onChangeAmount}
                onBlur={onAmountBlur}
                size='m'
              />
            )
          }

          const renderRental = () => {
            return (
              <DecimalInput
                name={'SumGroupId-' + rentalDiscount.SummationGroupConfigId + '-assessmentRates_Rental'}
                value={rentalDiscount.DiscountAmount}
                onChange={onChangeAmount}
                onBlur={onAmountBlur}
                size='m'
              />
            )
          }

          if (isKickback) {
            return (
              <Grid cols={['40%', '1fr', '1fr']} align='center' spacing={1} key={noRentalDiscount.SummationGroupConfigId}>
                <span>{noRentalDiscount.DiscountType}</span>
                {renderNoRental()}
                {rentalDiscount && renderRental()}
              </Grid>
            )
          } else {
            return (
              <Grid cols={['1fr', '1fr']} align='center' spacing={1} key={noRentalDiscount.SummationGroupConfigId}>
                <span>{noRentalDiscount.DiscountType}</span>
                {renderNoRental()}
              </Grid>
            )
          }
        }

        return (
          splicedItems.map(renderField)
        )
      }

      const renderHeadings = (isKickback) => {
        let amountText = '1295'
        let amountText2 = null
        let headingText = ''

        if (this.props.type === 'Addon') { // Addon
          headingText = translation('1396')
        } else {
          if (parseInt(this.props.type) === 1) { // Insurance claim
            headingText = translation('70')
            if (isKickback === true) {
              amountText = '18391'  // without rental car
              amountText2 = '18390' // with rental car
            }
          } else {
            headingText = translation(enumtranslate('OrderTypes', parseInt(this.props.type)))
          }
        }

        if (isKickback === true && this.props.isBodyShop === false) {
          amountText = '14904'
        }

        return (
          <Grid cols={amountText2 ? ['40%', '1fr', '1fr'] : ['1fr', '1fr']} align='center' spacing={1}>
            <span>{headingText}</span>
            <span>{translation(amountText)}</span>
            {amountText2 && <span>{translation(amountText2)}</span>}
          </Grid>
        )
      }

      return (
        <div>
          {this.props.hasKickback ? renderHeadings(true) : renderHeadings(false)}
          {renderDiscountFields()}
        </div>
      )
    }

    let titleText = translation('18368')
    if (isKickback) {
      titleText = translation('18367')
    }

    let helpText = ''
    switch (this.props.auth.departmentType) {
      case 0:
        helpText = `${translation('15026')} ${translation('15037')}`
        break
      case 1:
        helpText = isKickback ? translation('15212') : translation('15036')
        break
      case 2:
        helpText = `${translation('15026')} ${translation('15037')}`
        break
    }

    return (
      <div>
        <Col span='3'>
          <Panel title={titleText} helpText={helpText}>
            {renderDiscounts()}
          </Panel>
        </Col>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getAssessmentCustomerRates,
  updateAssessmentCustomerRates
})(ReportDiscounts)



// WEBPACK FOOTER //
// ./src/app/pages/Prices/Discounts/ReportDiscounts.js